module.exports = "<div class=\"notification-message-box {{type}}\">\n  <p>\n    <span>{{message}}</span>\n  </p>\n</div>\n"